import type { AttemptOperationId } from '@sportpark/shared/operation-attempt';
import { http } from './http-client';

import type {
  AudiencePreviewResponse,
  AudienceSendResponse,
  NotificationCategory as GenNotificationCategory,
  NotificationDto as GenNotificationDto,
  PreviewNotificationAudienceRequest,
  SendAdminMessageCommand,
  SendAdminMessageResponse,
  SendAudienceNotificationRequest,
} from './generated';

export type NotificationItem = GenNotificationDto;


export type NotificationChannel = 'push' | 'sms';

export type SendMessagePayload =
  Omit<SendAdminMessageCommand, 'channels' | 'clientOperationId'> & { channels?: NotificationChannel[]; clientOperationId: AttemptOperationId };

export type SendMessageResult = SendAdminMessageResponse;

export type NotificationCategory = `${GenNotificationCategory}`;

export interface PagedNotifications {
  items: NotificationItem[];
  totalCount: number;
  cursor: string | null;
  hasMore: boolean;
}

export interface ListNotificationsParams {
  isRead?: boolean;
  limit?: number;
  cursor?: string;
  category?: NotificationCategory;
}

export const notificationsApi = {
  list(params: ListNotificationsParams = {}, call?: { signal?: AbortSignal }): Promise<PagedNotifications> {
    return http.get<PagedNotifications>('/notifications', {
      query: {
        IsRead: params.isRead,
        Limit: params.limit,
        Cursor: params.cursor,
        Category: params.category,
      },
      signal: call?.signal,
    });
  },

  unreadCount(call?: { signal?: AbortSignal }): Promise<{ count: number }> {
    return http.get<{ count: number }>('/notifications/unread-count', { signal: call?.signal });
  },

  markRead(id: string): Promise<void> {
    return http.post<void>(`/notifications/${id}/read`);
  },

  markAllRead(): Promise<void> {
    return http.post<void>('/notifications/read-all');
  },

  send(payload: SendMessagePayload): Promise<SendMessageResult> {
    return http.post<SendMessageResult>('/notifications/send', payload);
  },

  audiencePreview(payload: PreviewNotificationAudienceRequest, call?: { signal?: AbortSignal }): Promise<AudiencePreviewResponse> {
    return http.post<AudiencePreviewResponse>('/notifications/audience/preview', payload, { signal: call?.signal });
  },

  audienceSend(payload: Omit<SendAudienceNotificationRequest, 'clientOperationId'> & { clientOperationId: AttemptOperationId }): Promise<AudienceSendResponse> {
    return http.post<AudienceSendResponse>('/notifications/audience/send', payload);
  },
};
